import { atom } from 'recoil'
import { IMaintenanceBlankSchema } from '../maintenance.types.ts'

interface IMaintenanceBlankSchemasAtomState {
  items: IMaintenanceBlankSchema[]
}

const maintenanceBlankSchemasAtom = atom<IMaintenanceBlankSchemasAtomState>({
  key: 'maintenance/blank-schemas',
  default: { items: [] },
})

export default maintenanceBlankSchemasAtom
